/**
 * ContentSize
 */
export var ContentSize;
(function (ContentSize) {
    ContentSize[ContentSize["SMALL"] = 100] = "SMALL";
    ContentSize[ContentSize["MEDIUM"] = 150] = "MEDIUM";
    ContentSize[ContentSize["LARGE"] = 200] = "LARGE";
    ContentSize[ContentSize["HUGE"] = 300] = "HUGE";
})(ContentSize || (ContentSize = {}));
//# sourceMappingURL=SliderEnum.js.map